import CryptoJS from 'crypto-js';

export const storeToken = (token: string) => {
  localStorage.setItem("accessToken", token);
};
export const clearToken = () => {
  localStorage.removeItem("accessToken");
};

export const isLoggedIn = () => {
  return !!localStorage.getItem("accessToken");
};
export const logoutUser = () => {
  // localStorage.clear();
};

const EXPIRY_MARGIN = 5 * 60;
export const storeLoginResponse = (loginResponse: any) => {
  const { userName, permissions, prefferedLanguage, prefferedMode, isActive } =
    loginResponse.user;
  localStorage.setItem("role", loginResponse.user.role.name);
  localStorage.setItem("userName", userName);
  localStorage.setItem("image", loginResponse.user.image);
  localStorage.setItem(
    "prefferedLanguage",
    prefferedLanguage === "English" ? "en" : "ar"
  );
  localStorage.setItem("prefferedMode", prefferedMode);
  localStorage.setItem("isActive", isActive);
  localStorage.setItem("accessToken", loginResponse.accessToken);
  localStorage.setItem(
    "expiresAt",
    Math.floor(Date.now() / 1000) +
    Number(loginResponse.expiresIn) -
    EXPIRY_MARGIN +
    ""
  );
  localStorage.setItem("startTime", new Date().toLocaleTimeString());
  localStorage.setItem("permissions", JSON.stringify(permissions));
};

export const getUserName = () => {
  return localStorage.getItem("userName");
};

export const getPermissions = () => {
  const permissions = localStorage.getItem("permissions");
  if (!permissions) {
    return [];
  }
  return JSON.parse(permissions);
};

export const isOwner = (): boolean => {
  return localStorage.getItem("role") === "owner";
};

const encryptData = (data: string): string => {
  return CryptoJS.AES.encrypt(data, process.env.ENCYPT_LOCAL_STORAGE_SECRET_KEY || '').toString();
};

const decryptData = (name: string): string | undefined => {
  try {
    const encrypted = localStorage.getItem(name);
    if (!encrypted) return undefined;

    return CryptoJS.AES.decrypt(encrypted, process.env.ENCYPT_LOCAL_STORAGE_SECRET_KEY || '').toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error('Error decrypting data:', error);
    return undefined;
  }
};

export const getIsGridViewLS = (): boolean => {
  const decryptedValue = decryptData("isGridView");
  return decryptedValue === 'true';
};

export const setIsGridViewLS = (value: boolean): void => {
  try {
    const encrypted = encryptData(value.toString());
    localStorage.setItem("isGridView", encrypted);
  } catch (error) {
    console.error('Error encrypting data:', error);
  }
};

export const getIsComplexPassword = (): boolean => {
  const decryptedValue = decryptData("isComplexPassword");
  return decryptedValue === 'true';
};

export const setIsComplexPassword = (value: boolean): void => {
  try {
    const encrypted = encryptData(value.toString());
    localStorage.setItem("isComplexPassword", encrypted);
  } catch (error) {
    console.error('Error encrypting data:', error);
  }
};

export const getIsPrintReceipt = (): boolean => {
  const decryptedValue = decryptData("isPrintReceipt");
  return decryptedValue === undefined || decryptedValue === 'true';
};

export const setIsPrintReceipt = (value: boolean): void => {
  try {
    const encrypted = encryptData(value.toString());
    localStorage.setItem("isPrintReceipt", encrypted);
  } catch (error) {
    console.error('Error encrypting data:', error);
  }
};

export const getReceiptLangLS = (): string | undefined => {
  const decryptedValue = decryptData("receiptLang");
  return decryptedValue ?? 'en';
};

export const setReceiptLangLS = (value: string): void => {
  try {
    const encrypted = encryptData(value.toString());
    localStorage.setItem("receiptLang", encrypted);
  } catch (error) {
    console.error('Error encrypting data:', error);
  }
};

export const getReceiptCurrLS = (): string | undefined => {
  const decryptedValue = decryptData("receiptCurr");
  return decryptedValue ?? 'usd';
};

export const setReceiptCurrLS = (value: string): void => {
  try {
    const encrypted = encryptData(value.toString());
    localStorage.setItem("receiptCurr", encrypted);
  } catch (error) {
    console.error('Error encrypting data:', error);
  }
};

export const numberWithCommas = (x: number, symbol: string): string => {
  return x != null && !isNaN(x)
    ? symbol + x.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
    : symbol + "0.00";
};

export const numberWithCommasLBP = (x: number, symbol: string): string => {
  return x != null && !isNaN(x)
    ? symbol + x.toFixed(0).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
    : symbol + "0";
}

export const formatedNumber = (x: number | 0, symbol: string): string => {
  return x != null && !isNaN(x)
    ? symbol + symbol === "$" ? x.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : x.toFixed(0).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
    : symbol + symbol === "$" ? "0.00" : "0";
};